import { render, staticRenderFns } from "./IntervalInput.vue?vue&type=template&id=63bc5cc3&scoped=true&"
import script from "./IntervalInput.vue?vue&type=script&lang=js&"
export * from "./IntervalInput.vue?vue&type=script&lang=js&"
import style0 from "./IntervalInput.vue?vue&type=style&index=0&id=63bc5cc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc5cc3",
  null
  
)

export default component.exports